import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=3600c5f0&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"
import style0 from "./SendSms.vue?vue&type=style&index=0&id=3600c5f0&prod&lang=scss"
import style1 from "./SendSms.vue?vue&type=style&index=1&id=3600c5f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600c5f0",
  null
  
)

export default component.exports